import { gql } from '@apollo/client';
import type {
  BreakDriverSideBreakdownPageResponseType,
  DeliveryProgressMonitoringOfSlaDetailPageResponseType,
  DeliveryProgressMonitoringOfSlaPageResponseType,
} from './getDeliveryProgressMonitoringOfSlaList';

// DSP 用户专用：与 GET_DELIVERY_PROGRESS_MONITORING_OF_SLA_PAGE_LIST 同字段，仅替换 operation 名为 ForDsp 版本
export const GET_DSP_DELIVERY_PROGRESS_MONITORING_OF_SLA_PAGE_LIST = gql`
  query GetDeliveryProgressMonitoringOfSlaPageListForDsp($pageRequest: DeliveryProgressMonitoringOfSlaPageRequestTypeInput!) {
    getDeliveryProgressMonitoringOfSlaPageListForDsp(pageRequest: $pageRequest) {
      calculatedAt
      summaryData {
        parcelsSummary {
          totalParcels
          actualArrivals
          pickedCount
          deliveredLatest
          missScanWhsArrivalCount
          returnedParcelIncompleteOver72hRate
          failedReturnedToWhsUnprocessedOver24hRate
          parcelWithReturnStartTimeCount
          parcelWithReturnWarehouseScanCount
        }
        anomalyData {
          aboutToBreak {
            total48To72h
            warehouseSide48To72h
            driverSide48To72h
          }
          alreadyBreak {
            totalOver72h
            warehouseSideOver72h
            driverSideOver72h
          }
          overtime {
            unpicked12h
            undelivered24h
          }
        }
        pieChartData {
          unpicked
          failedNotReturned
          failedReturnedToWhs
          inDelivery
          returnedParcel
          lostDamaged
        }
      }
      pageResponse {
        content {
          id
          warehouseId
          dspId
          areaId
          cityName
          driverId
          driverName
          arrivalPointType
          actualArrivals
          pickedCount
          unpickedCount
          inProgress
          deliveredLatest
          failedIncomplete
          failedReturnedToWhsCount
          returnedParcelCount
          lostDamagedCount
          missScanWhsArrivalCount
          returnedParcelIncompleteOver72hCount
          parcelWithReturnStartTimeCount
          failedReturnedToWhsUnprocessedOver24hCount
          parcelWithReturnWarehouseScanCount
          returnedParcelIncompleteOver72hRate
          failedReturnedToWhsUnprocessedOver24hRate
          noUpdate72To120hReturnedCount
          noUpdateOver120hReturnedCount
          latestDeliveryRate
          t1DeliveryRate
          t2DeliveryRate
          t3DeliveryRate
          t4DeliveryRate
          t5DeliveryRate
          anomalyUnpicked24h
          anomalyUndelivered24h
          anomalyUndelivered48h
          anomalyUndelivered72h
          anomalyAboutToTimeout24h
          anomalyAboutToTimeout48h
          anomalyNoUpdate24h
          anomalyNoUpdate72h
          anomalyNoUpdate72To120h
          anomalyNoUpdateOver120h
          anomalyUnpicked12h
          warehouseName
          dspName
          areaName
          createdAt
          updatedAt
          calculatedAt
          isDeleted
        }
        page
        size
        totalElements
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`;

export const GET_DSP_DELIVERY_PROGRESS_MONITORING_OF_SLA_DETAIL_LIST = gql`
  query GetDeliveryProgressMonitoringOfSlaDetailListForDsp($pageRequest: DeliveryProgressMonitoringOfSlaDetailPageRequestTypeInput!) {
    getDeliveryProgressMonitoringOfSlaDetailListForDsp(pageRequest: $pageRequest) {
      content {
        id
        arrivalDate
        taskDate
        warehouseId
        areaId
        cityName
        trackingNumber
        orderId
        lastOperateDspId
        lastOperateDriverId
        lastAssignDspId
        lastAssignDriverId
        lastOperateDspName
        lastOperateDriverName
        lastAssignDspName
        lastAssignDriverName
        overallStatus
        overallStatusText
        isUnpicked24h
        isUndelivered24h
        isUndelivered48h
        isUndelivered72h
        isAboutToTimeout24h
        isAboutToTimeout48h
        isNoUpdate24h
        isNoUpdate72h
        isActualArrivals
        isInDelivery
        isDeliveredLatest
        isReturnedDamagedLost
        isLostDamaged
        isFailedIncomplete
        isReturnedParcelIncompleteOver72h
        isParcelWithReturnStartTime
        isFailedReturnedToWhsUnprocessedOver24h
        isParcelWithReturnWarehouseScan
        warehouseName
        areaName
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_DSP_BREAK_DRIVER_SIDE_BREAKDOWN = gql`
  query GetBreakDriverSideBreakdownForDsp(
    $breakType: NoUpdateBreakType!
    $filter: DeliveryProgressMonitoringOfSlaFilterTypeInput!
    $page: Int!
    $size: Int!
  ) {
    getBreakDriverSideBreakdownForDsp(breakType: $breakType, filter: $filter, page: $page, size: $size) {
      content {
        dspId
        dspName
        count
        drivers {
          driverId
          driverName
          count
        }
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface GetDspDeliveryProgressMonitoringOfSlaPageListResponse {
  getDeliveryProgressMonitoringOfSlaPageListForDsp: DeliveryProgressMonitoringOfSlaPageResponseType;
}

export interface GetDspDeliveryProgressMonitoringOfSlaDetailListResponse {
  getDeliveryProgressMonitoringOfSlaDetailListForDsp: DeliveryProgressMonitoringOfSlaDetailPageResponseType;
}

export interface GetDspBreakDriverSideBreakdownResponse {
  getBreakDriverSideBreakdownForDsp: BreakDriverSideBreakdownPageResponseType;
}
